export default __webpack_public_path__ + "static/media/hrm.cf97c736.png";